export default class AchievementCreateRequest {
    constructor(supportedLocales) {
        const translations = [];
        supportedLocales.forEach((element) => {
            translations[element] = {
                title: '',
                description: '<span></span>',
                pushMessage: '',
                
            };
        });
        this.translations = translations;
        this.coinsToEarn = null;
        this.challengeType = null;
        this.activityType = null;
        this.measureUnit = null;
        this.goalValue = null;
        this.relatedToCommuteWork = null;
        this.action=null;
        this.sendPushWhenCompleted = true;
        this.pushMessage = null;
        this.type = 'ACHIEVEMENT';
    }
}
